import React from 'react';
import './Footer.scss';
import { Environments } from '@delta-defense/client-environments/environments/environments';

const Footer = () => {
  const isCabelasVariant = Environments.isCabelasShieldBrand();

  return (
    <div>
      {isCabelasVariant ? <footer><global-footer site="cabelasshield"></global-footer></footer> : <footer className="footer">
        <global-footer site="portal"></global-footer>
      </footer>}
    </div>
  );
};

export default Footer;
